import { WizardStep } from '@apply/components';
import { useStandardLoanStore } from '../../state/standardLoanStore';
import { SetupAndBorrower } from './components/SetupAndBorrower/SetupAndBorrower';
import { getSetupAndBorrowerProgress } from './components/SetupAndBorrower/functions/getSetupAndBorrowerProgress';
import { Loan } from './components/Loan/Loan';
import { getLoanProgress } from './components/Loan/LoanInfo/functions/getLoanProgress';
import { Expenses } from './components/Expenses/Expenses';
import { getExpensesProgress } from './components/Expenses/functions/getExpensesProgress';
import { PropertyRollup } from './components/PropertyRollup/PropertyRollup';
import { getPropertyRollupProgress } from './components/PropertyRollup/functions/getPropertyRollupProgress';
import { Repayments } from './components/Repayments/Repayments';
import { getRepaymentsProgress } from './components/Repayments/functions/getRepaymentsProgress';
import { StandardLoanSection } from './constants/standardLoanSection';
import { getPropertySteps } from './functions/getPropertySteps';
import { isPortfolioLoan } from '../../functions/isPortfolioLoan';

/**
 * The modal's steps, in order. Add a section to StandardLoanSection and a step here for each panel. A step's
 * progressBarInfo can be computed from its form data in the standard loan store (see useStandardLoanStore).
 */
export const useSteps = (): WizardStep[] => {
    const setup = useStandardLoanStore((state) => state.setup);
    const setupLoanContext = useStandardLoanStore((state) => state.setupLoanContext);
    const selectedTermKey = useStandardLoanStore((state) => state.selectedTermKey);
    const borrower = useStandardLoanStore((state) => state.borrower);
    const borrowerLoanContext = useStandardLoanStore((state) => state.borrowerLoanContext);
    const loan = useStandardLoanStore((state) => state.loan);
    const properties = useStandardLoanStore((state) => state.properties);
    // Every step after Setup & Borrower depends on the Loan Type, so they can't be opened until one is chosen in Setup
    const needsLoanType = setup.loanTypeId === undefined;
    const isPortfolio = isPortfolioLoan(setup.loanTypeId, properties.length);

    return [
        {
            number: StandardLoanSection.SetupAndBorrower,
            label: 'Setup & Borrower',
            header: 'Setup & Borrower',
            content: <SetupAndBorrower />,
            progressBarInfo: getSetupAndBorrowerProgress({
                setup,
                setupLoanContext,
                selectedTermKey,
                borrower,
                borrowerLoanContext,
            }),
        },
        {
            number: StandardLoanSection.Loan,
            label: 'Loan',
            header: 'Loan',
            content: <Loan />,
            progressBarInfo: getLoanProgress(loan, setup),
            disabled: needsLoanType,
        },
        ////Future Development
        // {
        //     number: StandardLoanSection.Expenses,
        //     label: 'Expenses',
        //     header: 'Expenses',
        //     content: <Expenses />,
        //     progressBarInfo: getExpensesProgress(),
        //     disabled: needsLoanType,
        // },
        // // Only portfolio loans (more than one property) have a rollup across their properties
        // ...(isPortfolio
        //     ? [
        //           {
        //               number: StandardLoanSection.PropertyRollup,
        //               label: 'Property Rollup',
        //               header: 'Property Rollup',
        //               content: <PropertyRollup />,
        //               progressBarInfo: getPropertyRollupProgress(),
        //               disabled: needsLoanType,
        //           },
        //       ]
        //     : []),
        // ...getPropertySteps({ properties, isPortfolio, needsLoanType }),
        // {
        //     number: StandardLoanSection.Repayments,
        //     label: 'Repayments',
        //     header: 'Repayments',
        //     content: <Repayments />,
        //     progressBarInfo: getRepaymentsProgress(),
        //     disabled: needsLoanType,
        // },
    ];
};
